/**
 * JoinENJoinWeekDemoView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait JoinENJoinWeekDemo
 */

import { useJoinENJoinWeekDemoLogic } from '@/hooks/traits/useJoinENJoinWeekDemoLogic';
import type { JoinENJoinWeekDemoConfig } from '@/hooks/traits/useJoinENJoinWeekDemoLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { JoinENDemoWeekStep } from '@app/shared';
import { JoinENDemoWeekTourView } from '@/components/traits/JoinENDemoWeekTourView';
import { Stack } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface JoinENJoinWeekDemoViewProps {
  config?: Partial<JoinENJoinWeekDemoConfig>;
}

export function JoinENJoinWeekDemoView({ config: propsConfig }: JoinENJoinWeekDemoViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useJoinENJoinWeekDemoLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['JoinENDemoWeekStep'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="JoinEN" trait="JoinENJoinWeekDemo">
      {slotWriter['main'] === 'INIT' ? (<Stack gap="md" direction="vertical"><JoinENDemoWeekTourView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}
    </TraitScopeProvider>
  );
}

export default JoinENJoinWeekDemoView;
